import { get } from "api/axiosApi";
import { env } from "utils/env";
const url = env.REACT_APP_LEASING_API_URL;
const getFinancialDataSummary = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/financialDataSummary`);
};

const exp = {
  getFinancialDataSummary
};
export default exp;
